
export class ProductParams {
    category: string;
    minPrice: number;
    maxPrice: number;
    minPoints: number;
    maxPoints: number;
    orderBy: string;

    constructor(category: string, minPrice: number, maxPrice: number, minPoints: number, maxPoints: number, orderBy: string) {
        this.category = category;
        this.minPrice = minPrice;
        this.maxPrice = maxPrice;
        this.minPoints = minPoints;
        this.maxPoints = maxPoints;
        this.orderBy = orderBy;
    }
  }